<div class="settings-card">
  <mat-accordion>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'PAGES.ADVANCED_SETTINGS.TITLE' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <span class="settings-name">
        {{ 'PAGES.ADVANCED_SETTINGS.SETTINGS.HTTPS_REDIRECT.NAME' | translate }}
      </span>
      <mat-slide-toggle
        [disabled]="disabled$ | async"
        [checked]="upgradeToHttps$ | async"
        (change)="toggleUpgradeToHttpsFlag($event.checked)"
      ></mat-slide-toggle>
      <div class="settings-description">
        <span>
          {{
            'PAGES.ADVANCED_SETTINGS.SETTINGS.HTTPS_REDIRECT.DESCRIPTION'
              | translate
          }}
        </span>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
